module.exports = global["$"] = require("-!C:\\work\\sega\\sega\\node_modules\\expose-loader\\index.js?jQuery!C:\\work\\sega\\sega\\node_modules\\source-map-loader\\index.js!C:\\work\\sega\\sega\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 1
// module chunks = 0